var App = App || {};

App.Masonry = (function ($) {
    'use strict';

    var Bps = ["lg", "xl", "xxl"],
        Bp = ZagBreakpoints.GetBreakpoint()

    function Init(Layout, ItemSelector) {

        if (Bps.includes(Bp)) { MasonrySetup(Layout, ItemSelector); }
        else { MasonryDestroy(Layout); }

        $(document).bind("enter-lg enter-xl enter-xxl", function () {
            MasonryDestroy(Layout, ItemSelector);
            MasonrySetup(Layout, ItemSelector);
        });

        $(document).bind("enter-xs enter-sm enter-md", function () {
            MasonryDestroy(Layout, ItemSelector);
        });

    }

    function MasonrySetup(Layout, ItemSelector) {
        if (!Layout.data('masonry')) {
            Layout.masonry({
                itemSelector: ItemSelector
            });
        }
    }

    function MasonryDestroy(Layout, ItemSelector) {
        if (Layout.data('masonry')) {
            Layout.masonry("destroy");
        }
    }

    return {
        Init: Init,
        MasonrySetup: MasonrySetup,
        MasonryDestroy: MasonryDestroy
    };

})(jQuery);
